<template>
  <!-- What is left of a hidden menu: ☰ brings the whole menu back, and each
       entry stays one click away as its icon. A group opens its first page. -->
  <div class="frame-chrome frame-rail">
    <button
      class="frame-rail__btn frame-rail__menu"
      type="button"
      aria-label="Näita menüüd"
      title="Näita menüüd"
      @click="$emit('show')"
    >
      <v-icon size="22">mdi-menu</v-icon>
    </button>
    <nav class="frame-rail__nav" aria-label="Peamenüü">
      <template v-for="(item, index) in items" :key="item.text">
        <div v-if="item.section === 'admin' && (index === 0 || items[index - 1].section !== 'admin')" class="frame-rail__rule" />
        <a
          v-if="item.href"
          :href="item.href"
          class="frame-rail__btn"
          :aria-label="item.text"
          :title="item.badge ? item.text + ' (' + item.badge + ')' : item.text"
        >
          <v-icon size="22">{{ item.icon }}</v-icon>
          <span v-if="item.badge" class="frame-rail__badge" aria-hidden="true">{{ item.badge }}</span>
        </a>
        <router-link
          v-else-if="target(item)"
          :to="target(item)"
          class="frame-rail__btn"
          :class="{ 'is-on': on(item) }"
          :aria-label="item.text"
          :title="item.text"
          :aria-current="on(item) ? 'page' : undefined"
        >
          <v-icon size="22">{{ item.icon }}</v-icon>
        </router-link>
      </template>
    </nav>
    <!-- The person, at the foot like in the full menu: Minu seaded, logging out. -->
    <profile-menu :location="side === 'right' ? 'start bottom' : 'end bottom'">
      <template #activator="{ props, initials, fullName }">
        <button class="frame-rail__btn frame-rail__me" type="button" aria-haspopup="dialog" :aria-label="fullName" :title="fullName" v-bind="props">
          <span class="frame-avatar" aria-hidden="true">{{ initials }}</span>
        </button>
      </template>
    </profile-menu>
  </div>
</template>

<script>
import ProfileMenu from './ProfileMenu.vue'
import frameLinks from './frameLinks'

export default {
  components: { ProfileMenu },
  mixins: [ frameLinks ],
  props: {
    items: { type: Array, required: true },
    side: { type: String, default: 'left' }
  },
  emits: ['show'],
  methods: {
    // The entry's own page, or its group's first page (a group inside the
    // group: that one's first page).
    target (item) {
      if (item.link) return item.link
      let first = (item.children || [])[0]
      while (first && first.children) first = first.children[0]
      return first ? first.link : null
    },
    on (item) {
      return item.children ? this.groupOn(item) : this.isOn(item.link)
    }
  }
}
</script>
